import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'

import Address from './Address'
import Label from '~/components/Form/Label'
import UseSavedPaymentData from '../UseSavedPaymentData'

const Container = styled.div`
  display: flex;
  flex-direction: column;

`

@inject(all => ({
  payment: all.store.payment,
  user: all.store.auth.user,
  hasFullAddress: all.store.auth.user.hasFullAddress,
  defaultPaymentMethod: all.store.payment.defaultPaymentMethod,
  hasDefaultPaymentMethod: all.store.payment.hasDefaultPaymentMethod,
  isChangingAddress: all.store.payment.isChangingAddress
}))
@observer
class UserAddressComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userHasInitialAddress: props.hasFullAddress
    }
  }

  render() {
    const { hasFullAddress, isChangingAddress, payment, user } = this.props
    if (!user || !user.hasFullAddress) return null

    return (
      <Container isChangingAddress={isChangingAddress}>
        {!isChangingAddress ? (
          hasFullAddress && (
            <>
              <Label>Billing Address</Label>
              <Address
                address={user.address}
                city={user.city}
                countryState={user.countryState}
                zipcode={user.zipcode}
                addHandler={payment.toggleChangeAddress}
              />
            </>
          )
        ) : (
          <UseSavedPaymentData onClick={payment.toggleChangeAddress}>
            Use saved address
          </UseSavedPaymentData>
        )}
      </Container>
    )
  }
}

export default UserAddressComponent
